import { render, staticRenderFns } from "./adminApproveQuestionnaire.vue?vue&type=template&id=2bdd43aa&"
import script from "./adminApproveQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./adminApproveQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./adminApproveQuestionnaire.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports